import {Svg, LinearGradient, Stop, Rect, Defs, View, Text} from '@react-pdf/renderer'
import {styles} from './Styles'
import theme from '../../../../../themes/pTheme/pTheme'

const colors = [
  theme.palette.hpAccentLightYellow,
  theme.palette.hpAccentYellowGreen,
  theme.palette.hpAccentAqua,
  theme.palette.hpAccentAquaGreen,
  theme.palette.hpAccentPersianGreen,
  theme.palette.hpPrimaryDark,
  theme.palette.hpPrimaryDarkest
]

const colorLegendSVG = (
  <Svg style={{width: 140, height: 6, border: 1, marginHorizontal: 1}}>
    <Defs>
      <LinearGradient id='legend-gradient' x1='0%' y1='0%' x2='100%' y2='0%'>
        {colors.map((color, i) => (
          <Stop key={color} offset={`${(i / (colors.length - 1)) * 100}%`} stopColor={color} />
        ))}
      </LinearGradient>
    </Defs>
    <Rect width={140} height={6} fill='url("#legend-gradient")' strokeWidth={1} stroke='grey' />
  </Svg>
)
export const ColorLegend = (
  <View style={styles.colorLegendContainer}>
    <Text style={[styles.textRegular]}>Low Density</Text>
    {colorLegendSVG}
    <Text style={[styles.textRegular]}>High Density</Text>
  </View>
)

/**
 * List of functions and their purpose:
 *
 * - ColorLegend: Renders a horizontal color gradient legend for PDF layouts, representing data density from low to high.
 */
